module.exports = __webpack_public_path__ + "static/media/06.112.a65896b8.webp";